module.exports = __webpack_public_path__ + "static/media/about-certificate-img12.5051591f.jpg";